// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CjUL1","wrapper":"styles_wrapper__mGHW-","label":"styles_label__vsEHJ","search":"styles_search__cupih"};